import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';
import { Dialog, Loading } from 'common/components';

type ReconnectingModalProps = {
  isOpen: boolean;
};

export const ReconnectingModal = ({ isOpen }: ReconnectingModalProps) => {
  const { t: tLoading } = useTranslation('common', { keyPrefix: 'loading' });
  return (
    <Dialog
      isOpen={isOpen}
      title="Reconnecting"
      description="Connection to server lost. Reconnecting..."
      showCancelButton={false}
      showCloseButton={false}
      disableClickOutside
    >
      <Box py={2}>
        <Loading label={tLoading('reconnectingToNatter')} />
      </Box>
    </Dialog>
  );
};
